import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarComponent } from './omnibar';
export * from './omnibar-adapter';
export * from './omnibar-constants';
export * from './omnibar-foundation';
export * from './omnibar';
export function defineOmnibarComponent() {
    defineCustomElement(OmnibarComponent);
}
